export default __webpack_public_path__ + "static/media/banner_1.727273e7.JPG";